<template>
  <v-container fluid style="max-width: 96%">
    <div class="provider">
      <BaseTitle :pageTitle="pageTitle" />
      <v-row>
        <v-col>
          <Form :pageTitle="pageTitle"></Form>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Form from "./_components/form";
import BaseTitle from "../../components/UI/BaseTitle";

export default {
  name: "RegisterProviderIdentifier",
  components: {
    BaseTitle,
    Form
  },
  data: () => ({
    pageTitle: ""
  }),
  created() {
    if (
      this.$route.name === "providers.visualizar" ||
      this.$route.name === "providers.validation.visualizar"
    ) {
      return (this.pageTitle = "VISUALIZAR FORNECEDOR");
    } else {
      return (this.pageTitle = "CADASTRO DE FORNECEDOR");
    }
  }
};
</script>

<style lang="scss" scoped>
.text-instructions {
  background-color: #eeeeee;
  border-radius: 10px;
  padding: 10px 10px 1px 10px;
}
.title {
  letter-spacing: 0.1666666667em !important;
}
</style>
